"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LiveEngage = void 0;

var _helpStorage = require("@ua/help-storage");

var _http = require("../http");

var _store = require("../store");

var _conversation = require("../store/actions/conversation");

var _app = require("../store/actions/app");

var _app2 = require("../store/selectors/app");

var _conversation2 = require("../store/selectors/conversation");

var _util = require("../util");

var _constants = require("../constants");

var _traffic = require("../store/actions/traffic");

var LEMessage = _interopRequireWildcard(require("./LiveEngageMessages"));

var _LiveEngageConfig = _interopRequireWildcard(require("./LiveEngageConfig"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LiveEngage =
/*#__PURE__*/
function () {
  function LiveEngage(newStore) {
    var _this = this;

    _classCallCheck(this, LiveEngage);

    this.store = newStore || _store.store;
    this.jwtExternalToken = null;
    this.jwtInternalToken = null;
    this.conversationId = null;
    this.conversationSequenceNumber = 0;
    this.visitorId = null;
    this.sessionId = null;
    this.ws = null;
    this.runKeepAlive = true;
    this.agentConnectTimeout = null;
    this.typingAgentTimeout = null;
    this.typingUserTimeout = null;
    var env = (0, _app2.getAppEnv)(this.store.getState());
    var product = (0, _app2.getAppProduct)(this.store.getState());
    this.config = (0, _LiveEngageConfig["default"])(env, product);

    this.debug = function () {
      return (0, _app2.getAppDebug)(_this.store.getState());
    };

    this.agentData = null;
    this.agentConnected = false;
    this.managerData = [];
    this.participantProfileData = {};
    this.userLeavingChatQueue = false;
    this.shouldRefreshToken = false;
  }

  _createClass(LiveEngage, [{
    key: "init",
    value: function init(newStore) {
      var _this2 = this;

      var env, product;
      return regeneratorRuntime.async(function init$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.log('LE Init.');
              this.store = newStore || _store.store;
              _context.next = 4;
              return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_LiveEngageConfig.LE_EXTERNAL_TOKEN_KEY));

            case 4:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t0 = null;

            case 7:
              this.jwtExternalToken = _context.t0;
              _context.next = 10;
              return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_LiveEngageConfig.LE_INTERNAL_TOKEN_KEY));

            case 10:
              _context.t1 = _context.sent;

              if (_context.t1) {
                _context.next = 13;
                break;
              }

              _context.t1 = null;

            case 13:
              this.jwtInternalToken = _context.t1;
              _context.next = 16;
              return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_LiveEngageConfig.LE_CONVERSATION_ID_KEY));

            case 16:
              _context.t2 = _context.sent;

              if (_context.t2) {
                _context.next = 19;
                break;
              }

              _context.t2 = null;

            case 19:
              this.conversationId = _context.t2;
              _context.next = 22;
              return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_LiveEngageConfig.LE_CONVERSATION_SEQUENCE_NUMBER_KEY));

            case 22:
              _context.t3 = _context.sent;

              if (_context.t3) {
                _context.next = 25;
                break;
              }

              _context.t3 = 0;

            case 25:
              this.conversationSequenceNumber = _context.t3;
              _context.next = 28;
              return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_LiveEngageConfig.LE_VISITOR_ID_KEY));

            case 28:
              _context.t4 = _context.sent;

              if (_context.t4) {
                _context.next = 31;
                break;
              }

              _context.t4 = null;

            case 31:
              this.visitorId = _context.t4;
              _context.next = 34;
              return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_LiveEngageConfig.LE_SESSION_ID_KEY));

            case 34:
              _context.t5 = _context.sent;

              if (_context.t5) {
                _context.next = 37;
                break;
              }

              _context.t5 = null;

            case 37:
              this.sessionId = _context.t5;
              env = (0, _app2.getAppEnv)(this.store.getState());
              product = (0, _app2.getAppProduct)(this.store.getState());
              this.config = (0, _LiveEngageConfig["default"])(env, product);

              this.debug = function () {
                return (0, _app2.getAppDebug)(_this2.store.getState());
              };

              _context.next = 44;
              return regeneratorRuntime.awrap(this.getJwt());

            case 44:
              this.ws = new WebSocket(this.config.socketUrl);
              _context.next = 47;
              return regeneratorRuntime.awrap(this.setSocketOnOpen());

            case 47:
              _context.next = 49;
              return regeneratorRuntime.awrap(this.setSocketOnError());

            case 49:
              _context.next = 51;
              return regeneratorRuntime.awrap(this.setSocketOnMessage());

            case 51:
              _context.next = 53;
              return regeneratorRuntime.awrap(this.setSocketOnClose());

            case 53:
              _context.next = 55;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appContextSet)(_constants.CONTEXT_LIVE_ENGAGE)));

            case 55:
              clearTimeout(this.agentConnectTimeout);
              this.agentConnectTimeout = setTimeout(function () {
                _this2.store.dispatch((0, _traffic.trafficLESocketOnError)('agent connect timeout'));
              }, this.config.agentConnectTimeoutMs);

            case 57:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    } // We want to delete live-Engage store keys every time user ends the chat or agent ends the chat.
    // Not deleting these may cause next chat calls trying to resue them and can lead to failures.

  }, {
    key: "deleteLiveEngageStoredKeys",
    value: function deleteLiveEngageStoredKeys() {
      return regeneratorRuntime.async(function deleteLiveEngageStoredKeys$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return regeneratorRuntime.awrap((0, _helpStorage.removeItem)(_LiveEngageConfig.LE_VISITOR_ID_KEY));

            case 2:
              _context2.next = 4;
              return regeneratorRuntime.awrap((0, _helpStorage.removeItem)(_LiveEngageConfig.LE_SESSION_ID_KEY));

            case 4:
              _context2.next = 6;
              return regeneratorRuntime.awrap((0, _helpStorage.removeItem)(_LiveEngageConfig.LE_EXTERNAL_TOKEN_KEY));

            case 6:
              _context2.next = 8;
              return regeneratorRuntime.awrap((0, _helpStorage.removeItem)(_LiveEngageConfig.LE_INTERNAL_TOKEN_KEY));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      return regeneratorRuntime.async(function reset$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.jwtInternalToken = null;
              this.conversationId = null;
              this.conversationSequenceNumber = 0;
              this.visitorId = null;
              this.sessionId = null;
              _context3.next = 7;
              return regeneratorRuntime.awrap(this.deleteLiveEngageStoredKeys());

            case 7:
              this.agentConnected = false;
              _context3.next = 10;
              return regeneratorRuntime.awrap(this.closeSocket());

            case 10:
              _context3.next = 12;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appContextReset)()));

            case 12:
              this.log("%cLE UTILITY: LE Reset", (0, _util.consoleCss)('#BBB', '#AAFFFF'));

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getJwt",
    value: function getJwt() {
      var _this3 = this;

      var authorizeData, authorizeResponse, authenticateResponse;
      return regeneratorRuntime.async(function getJwt$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!this.shouldRefreshToken && this.jwtInternalToken)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              authorizeData = null;

              if (this.shouldRefreshToken && this.jwtExternalToken) {
                authorizeData = JSON.stringify({
                  id_token: this.jwtExternalToken
                });
                this.shouldRefreshToken = false;
              }

              _context4.next = 6;
              return regeneratorRuntime.awrap((0, _util.retry)(function () {
                return (0, _http.request)({
                  url: _this3.config.authorizeUrl,
                  method: _util.postProps.method,
                  headers: _util.postProps.headers,
                  data: authorizeData
                });
              }, this.config.retries, this.config.retryInterval));

            case 6:
              authorizeResponse = _context4.sent;
              this.log('LE-TOKEN: Retrieved authorization token');
              this.jwtExternalToken = authorizeResponse.data.token;
              _context4.next = 11;
              return regeneratorRuntime.awrap((0, _helpStorage.setItem)('LEExternalToken', this.jwtExternalToken));

            case 11:
              _context4.next = 13;
              return regeneratorRuntime.awrap((0, _util.retry)(function () {
                return (0, _http.request)({
                  url: _this3.config.authenticateUrl,
                  method: _util.postProps.method,
                  headers: _util.postProps.headers,
                  data: JSON.stringify({
                    id_token: _this3.jwtExternalToken
                  })
                });
              }, this.config.retries, this.config.retryInterval));

            case 13:
              authenticateResponse = _context4.sent;
              this.log('LE-TOKEN: Retrieved authentication token');
              this.jwtInternalToken = authenticateResponse.data.token;
              _context4.next = 18;
              return regeneratorRuntime.awrap((0, _helpStorage.setItem)('LEInternalToken', this.jwtInternalToken));

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleUserEndChat",
    value: function handleUserEndChat() {
      return regeneratorRuntime.async(function handleUserEndChat$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return regeneratorRuntime.awrap(this.sendSocketMessage(LEMessage.updateConversationField(this.conversationId)));

            case 2:
              _context5.next = 4;
              return regeneratorRuntime.awrap(this.handleConversationEnded());

            case 4:
              _context5.next = 6;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appBlockedSet)(false)));

            case 6:
              this.agentConnected = false;

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "retrieveEngagement",
    value: function retrieveEngagement() {
      var _this4 = this;

      var params, engagementAttributes, response, _response$data, sessionId, visitorId;

      return regeneratorRuntime.async(function retrieveEngagement$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              this.log('LE-ENGAGEMENT: called.');

              if (!(this.sessionId && this.visitorId)) {
                _context6.next = 3;
                break;
              }

              return _context6.abrupt("return");

            case 3:
              params = {};
              if (this.sessionId) params.sessionId = this.sessionId;
              if (this.visitorId) params.visitorId = this.visitorId;
              _context6.next = 8;
              return regeneratorRuntime.awrap(this.getSDEs());

            case 8:
              engagementAttributes = _context6.sent;
              _context6.prev = 9;
              _context6.next = 12;
              return regeneratorRuntime.awrap((0, _util.retry)(function () {
                return (0, _http.request)({
                  url: _this4.config.engagementUrl,
                  method: _util.postProps.method,
                  headers: _util.postProps.headers,
                  params: params,
                  data: JSON.stringify({
                    engagementAttributes: engagementAttributes
                  })
                });
              }, this.config.retries, this.config.retryInterval));

            case 12:
              response = _context6.sent;
              _context6.next = 18;
              break;

            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](9);
              this.log('LE-ENGAGEMENT: Error');

            case 18:
              this.log('LE-ENGAGEMENT: Retrieved');

              if (!(response && response.data)) {
                _context6.next = 30;
                break;
              }

              _response$data = response.data, sessionId = _response$data.sessionId, visitorId = _response$data.visitorId;

              if (!sessionId) {
                _context6.next = 25;
                break;
              }

              this.sessionId = sessionId;
              _context6.next = 25;
              return regeneratorRuntime.awrap((0, _helpStorage.setItem)(_LiveEngageConfig.LE_SESSION_ID_KEY, sessionId));

            case 25:
              if (!visitorId) {
                _context6.next = 29;
                break;
              }

              this.visitorId = visitorId;
              _context6.next = 29;
              return regeneratorRuntime.awrap((0, _helpStorage.setItem)(_LiveEngageConfig.LE_VISITOR_ID_KEY, visitorId));

            case 29:
              return _context6.abrupt("return", {
                visitorId: visitorId,
                sessionId: sessionId
              });

            case 30:
              return _context6.abrupt("return", {
                visitorId: undefined,
                sessionId: undefined
              });

            case 31:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this, [[9, 15]]);
    }
  }, {
    key: "consumerRequestConversation",
    value: function consumerRequestConversation() {
      var _this5 = this;

      var props;
      return regeneratorRuntime.async(function consumerRequestConversation$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              props = {
                accountId: this.config.accountId,
                visitorId: this.visitorId,
                sessionId: this.sessionId,
                skillId: this.config.skillId
              };
              this.log("Conversation ID: ".concat(this.conversationId));

              if (this.conversationId) {
                _context7.next = 7;
                break;
              }

              _context7.next = 5;
              return regeneratorRuntime.awrap(this.sendSocketMessage(LEMessage.consumerRequestConversation(props)));

            case 5:
              _context7.next = 9;
              break;

            case 7:
              clearTimeout(this.agentConnectTimeout);
              this.agentConnected = true;

            case 9:
              this.log("Awaiting Conversation ID: ".concat(this.conversationId));
              _context7.next = 12;
              return regeneratorRuntime.awrap((0, _util.intervalUntil)(function () {
                return _this5.conversationId;
              }, 100));

            case 12:
              _context7.next = 14;
              return regeneratorRuntime.awrap(this.sendSocketMessage(LEMessage.subscribeMessagingEvents({
                conversationId: this.conversationId,
                sequenceNumber: this.conversationSequenceNumber
              })));

            case 14:
              _context7.next = 16;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appConversationIdSet)(this.conversationId)));

            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "sendChatState",
    value: function sendChatState(state) {
      return regeneratorRuntime.async(function sendChatState$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return regeneratorRuntime.awrap(this.sendSocketMessage(LEMessage.chatState(this.conversationId, state)));

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "startKeepAlive",
    value: function startKeepAlive() {
      var _this6 = this;

      return regeneratorRuntime.async(function startKeepAlive$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              this.runKeepAlive = true;
              _context9.next = 3;
              return regeneratorRuntime.awrap((0, _util.intervalUntil)(function () {
                if (!_this6.runKeepAlive) return true;
                var socketState = _this6.ws && _this6.ws.readyState;

                if (socketState === WebSocket.OPEN) {
                  _this6.sendSocketMessage(LEMessage.getClock());
                }
              }, this.config.keepAliveInterval));

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "fetchParticipantProfile",
    value: function fetchParticipantProfile(participantId) {
      var participantProfileData, _this$config, chatbotsApiUrl, accountId, participantData, agentDataResponse, data, pictureUrl;

      return regeneratorRuntime.async(function fetchParticipantProfile$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              participantProfileData = this.participantProfileData;

              if (!participantProfileData[participantId]) {
                _context10.next = 3;
                break;
              }

              return _context10.abrupt("return", participantProfileData[participantId]);

            case 3:
              _this$config = this.config, chatbotsApiUrl = _this$config.chatbotsApiUrl, accountId = _this$config.accountId;
              participantData = {
                id: participantId
              };
              _context10.next = 7;
              return regeneratorRuntime.awrap((0, _http.request)({
                method: 'get',
                url: "".concat(chatbotsApiUrl, "/agent/").concat(accountId, "/").concat(participantId)
              }));

            case 7:
              agentDataResponse = _context10.sent;

              if (agentDataResponse.error) {
                participantData = {
                  id: participantId,
                  nickname: null,
                  pictureUrl: ''
                };
              } else {
                data = agentDataResponse.data;
                pictureUrl = data.pictureUrl || '';
                participantData = _objectSpread({
                  id: participantId,
                  pictureUrl: pictureUrl
                }, data);
              }

              this.participantProfileData[participantId] = participantData;
              return _context10.abrupt("return", participantData);

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleConversationStarted",
    value: function handleConversationStarted() {
      var _this$config2, skillName, accountId, chatbotsApiUrl, params, _ref, data, waitTime;

      return regeneratorRuntime.async(function handleConversationStarted$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!this.agentConnected) {
                _context11.next = 2;
                break;
              }

              return _context11.abrupt("return");

            case 2:
              _this$config2 = this.config, skillName = _this$config2.skillName, accountId = _this$config2.accountId, chatbotsApiUrl = _this$config2.chatbotsApiUrl;
              params = {
                skillId: skillName,
                account: accountId
              };
              _context11.next = 6;
              return regeneratorRuntime.awrap((0, _http.request)({
                method: 'get',
                params: params,
                url: "".concat(chatbotsApiUrl, "/agentWaitTime")
              }));

            case 6:
              _ref = _context11.sent;
              data = _ref.data;
              // Note: If estimatedWaitTime is -2, this indicates that there is not enough data to predict the estimated wait time.
              waitTime = data && typeof data.estimatedWaitTime !== 'undefined' && data.estimatedWaitTime !== -2 ? data.estimatedWaitTime : null;
              _context11.next = 11;
              return regeneratorRuntime.awrap(this.addToConversation(_constants.CONVERSATION_TYPE_WAIT_FOR_HUMAN, [waitTime], true));

            case 11:
              this.store.dispatch((0, _traffic.trafficUserQueued)());

            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleAgentConnected",
    value: function handleAgentConnected() {
      return regeneratorRuntime.async(function handleAgentConnected$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              clearTimeout(this.agentConnectTimeout);

              if (!((0, _app2.getAppContext)(this.store.getState()) !== _constants.CONTEXT_LIVE_ENGAGE)) {
                _context12.next = 3;
                break;
              }

              return _context12.abrupt("return");

            case 3:
              _context12.next = 5;
              return regeneratorRuntime.awrap(this.fetchParticipantProfile(this.agentData.id));

            case 5:
              this.agentData = _context12.sent;

              if (!this.agentConnected) {
                _context12.next = 8;
                break;
              }

              return _context12.abrupt("return");

            case 8:
              _context12.next = 10;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.conversationRemoveLast)(_constants.CONVERSATION_TYPE_WAIT_FOR_HUMAN)));

            case 10:
              _context12.next = 12;
              return regeneratorRuntime.awrap(this.addToConversation(_constants.CONVERSATION_TYPE_TEXT_HUMAN_START, [this.agentData]));

            case 12:
              _context12.next = 14;
              return regeneratorRuntime.awrap(this.sendConversationContext());

            case 14:
              this.store.dispatch((0, _traffic.trafficAgentActionStart)());
              this.agentConnected = true;

            case 16:
            case "end":
              return _context12.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleAgentDisconnected",
    value: function handleAgentDisconnected() {
      return regeneratorRuntime.async(function handleAgentDisconnected$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return regeneratorRuntime.awrap(this.addToConversation(_constants.CONVERSATION_TYPE_TEXT_HUMAN_LEAVE, [this.agentData]));

            case 2:
              _context13.next = 4;
              return regeneratorRuntime.awrap(this.sendConversationContext());

            case 4:
            case "end":
              return _context13.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleManagerConnected",
    value: function handleManagerConnected(managerId) {
      var manager, _ref2, nickname, pictureUrl;

      return regeneratorRuntime.async(function handleManagerConnected$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              manager = this.managerData.find(function (m) {
                return m.id === managerId;
              });
              _context14.next = 3;
              return regeneratorRuntime.awrap(this.fetchParticipantProfile(manager.id));

            case 3:
              _ref2 = _context14.sent;
              nickname = _ref2.nickname;
              pictureUrl = _ref2.pictureUrl;
              manager.nickname = nickname;
              manager.pictureUrl = pictureUrl;
              _context14.next = 10;
              return regeneratorRuntime.awrap(this.addToConversation(_constants.CONVERSATION_TYPE_TEXT_HUMAN_JOIN, [manager]));

            case 10:
              _context14.next = 12;
              return regeneratorRuntime.awrap(this.sendConversationContext());

            case 12:
            case "end":
              return _context14.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleManagerDisonnected",
    value: function handleManagerDisonnected(managerId) {
      var manager;
      return regeneratorRuntime.async(function handleManagerDisonnected$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              manager = this.managerData.find(function (m) {
                return m.id === managerId;
              });
              this.managerData = this.managerData.filter(function (m) {
                return m.id !== managerId;
              });
              _context15.next = 4;
              return regeneratorRuntime.awrap(this.addToConversation(_constants.CONVERSATION_TYPE_TEXT_HUMAN_LEAVE, [manager]));

            case 4:
              _context15.next = 6;
              return regeneratorRuntime.awrap(this.sendConversationContext());

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "addToConversation",
    value: function addToConversation(conversationType, items) {
      var blockInput,
          response,
          _args16 = arguments;
      return regeneratorRuntime.async(function addToConversation$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              blockInput = _args16.length > 2 && _args16[2] !== undefined ? _args16[2] : false;
              response = {
                error: null,
                responses: []
              };
              response.responses.push({
                type: conversationType,
                items: items
              });
              _context16.next = 5;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.conversationQueueAppend)(response.responses)));

            case 5:
              _context16.next = 7;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.processQueue)()));

            case 7:
              _context16.next = 9;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appBlockedSet)(blockInput)));

            case 9:
            case "end":
              return _context16.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "sendConversationContext",
    value: function sendConversationContext() {
      var _this7 = this;

      var getLatestState;
      return regeneratorRuntime.async(function sendConversationContext$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              getLatestState = function getLatestState() {
                return _this7.store.getState();
              };

              _context17.next = 3;
              return regeneratorRuntime.awrap(this.send((0, _conversation2.getConversationTranscript)(getLatestState())));

            case 3:
              _context17.next = 5;
              return regeneratorRuntime.awrap(this.send((0, _app2.getAppProductContext)(getLatestState(), (0, _app2.getAppEnv)(getLatestState()))));

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "disconnectFromConversation",
    value: function disconnectFromConversation() {
      return regeneratorRuntime.async(function disconnectFromConversation$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              this.conversationId = null;
              _context18.next = 3;
              return regeneratorRuntime.awrap((0, _helpStorage.removeItem)(_LiveEngageConfig.LE_CONVERSATION_ID_KEY));

            case 3:
              this.conversationSequenceNumber = 0;
              _context18.next = 6;
              return regeneratorRuntime.awrap((0, _helpStorage.removeItem)(_LiveEngageConfig.LE_CONVERSATION_SEQUENCE_NUMBER_KEY));

            case 6:
              _context18.next = 8;
              return regeneratorRuntime.awrap(this.closeSocket());

            case 8:
              _context18.next = 10;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appContextReset)()));

            case 10:
            case "end":
              return _context18.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleConversationEnded",
    value: function handleConversationEnded() {
      var response;
      return regeneratorRuntime.async(function handleConversationEnded$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return regeneratorRuntime.awrap(this.disconnectFromConversation());

            case 2:
              response = {
                error: null,
                responses: []
              };
              response.responses.push({
                type: _constants.CONVERSATION_TYPE_TEXT_HUMAN_END,
                items: [this.agentData]
              });
              _context19.next = 6;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.conversationQueueAppend)(response.responses)));

            case 6:
              _context19.next = 8;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.processQueue)()));

            case 8:
              if (!this.agentConnected) {
                _context19.next = 11;
                break;
              }

              _context19.next = 11;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.conversationSend)(_constants.SLASH_COMMAND_SURVEY)));

            case 11:
              _context19.next = 13;
              return regeneratorRuntime.awrap(this.deleteLiveEngageStoredKeys());

            case 13:
              this.store.dispatch((0, _traffic.trafficAgentActionEnd)());

            case 14:
            case "end":
              return _context19.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleUserLeaveChatQueue",
    value: function handleUserLeaveChatQueue() {
      return regeneratorRuntime.async(function handleUserLeaveChatQueue$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              this.userLeavingChatQueue = true;
              _context20.next = 3;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appContextReset)()));

            case 3:
              _context20.next = 5;
              return regeneratorRuntime.awrap(this.handleUserEndChat());

            case 5:
              this.store.dispatch((0, _traffic.trafficUserLeaveQueue)());

            case 6:
            case "end":
              return _context20.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleUserLeftChatQueue",
    value: function handleUserLeftChatQueue() {
      return regeneratorRuntime.async(function handleUserLeftChatQueue$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return regeneratorRuntime.awrap(this.disconnectFromConversation());

            case 2:
              _context21.next = 4;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.conversationSend)('', _constants.EVENT_TYPE_CHAT_LEAVE_QUEUE)));

            case 4:
              _context21.next = 6;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _app.appBlockedSet)(false)));

            case 6:
              this.userLeavingChatQueue = false;

            case 7:
            case "end":
              return _context21.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "closeSocket",
    value: function closeSocket() {
      return regeneratorRuntime.async(function closeSocket$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.close();
                this.ws = null;
                this.runKeepAlive = false;
              }

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "setSocketOnOpen",
    value: function setSocketOnOpen() {
      var _this8 = this;

      return regeneratorRuntime.async(function setSocketOnOpen$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              this.log('SOCKET: setting socket on open.');

              this.ws.onopen = function _callee() {
                return regeneratorRuntime.async(function _callee$(_context23) {
                  while (1) {
                    switch (_context23.prev = _context23.next) {
                      case 0:
                        _this8.log('SOCKET: socket on open.');

                        _this8.store.dispatch((0, _traffic.trafficLESocketOnOpen)());

                        _context23.next = 4;
                        return regeneratorRuntime.awrap(_this8.sendSocketMessage(LEMessage.consumerAuthentication(_this8.jwtInternalToken)));

                      case 4:
                        _context23.next = 6;
                        return regeneratorRuntime.awrap(_this8.sendSocketMessage(LEMessage.getUserProfile()));

                      case 6:
                        _context23.next = 8;
                        return regeneratorRuntime.awrap(_this8.sendSocketMessage(LEMessage.getBrandProfile(_this8.config.accountId)));

                      case 8:
                        _context23.next = 10;
                        return regeneratorRuntime.awrap(_this8.sendSocketMessage(LEMessage.subscribeExConversations()));

                      case 10:
                        _context23.next = 12;
                        return regeneratorRuntime.awrap(_this8.retrieveEngagement());

                      case 12:
                        _context23.next = 14;
                        return regeneratorRuntime.awrap(_this8.consumerRequestConversation());

                      case 14:
                        _context23.next = 16;
                        return regeneratorRuntime.awrap(_this8.startKeepAlive());

                      case 16:
                      case "end":
                        return _context23.stop();
                    }
                  }
                });
              };

            case 2:
            case "end":
              return _context24.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "setSocketOnError",
    value: function setSocketOnError() {
      var _this9 = this;

      return regeneratorRuntime.async(function setSocketOnError$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              this.log('SOCKET: setting socket on error.');

              this.ws.onerror = function _callee2(event) {
                return regeneratorRuntime.async(function _callee2$(_context25) {
                  while (1) {
                    switch (_context25.prev = _context25.next) {
                      case 0:
                        _this9.log('SOCKET: socket on error.');

                        _this9.store.dispatch((0, _traffic.trafficLESocketOnError)(JSON.stringify(event) || ''));

                        console.error('WebSocket error observed:', event);

                      case 3:
                      case "end":
                        return _context25.stop();
                    }
                  }
                });
              };

            case 2:
            case "end":
              return _context26.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleMessagingEventNotify",
    value: function handleMessagingEventNotify(data) {
      var _this10 = this;

      var messageEventData;
      return regeneratorRuntime.async(function handleMessagingEventNotify$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              messageEventData = data && data.body && data.body.changes && data.body.changes;
              _context28.next = 3;
              return regeneratorRuntime.awrap(messageEventData.forEach(function _callee3(entry) {
                var _entry$event, chatState, message, type, _entry$originatorMeta, id, role, sequence;

                return regeneratorRuntime.async(function _callee3$(_context27) {
                  while (1) {
                    switch (_context27.prev = _context27.next) {
                      case 0:
                        if (!entry) {
                          _context27.next = 15;
                          break;
                        }

                        _entry$event = entry.event, chatState = _entry$event.chatState, message = _entry$event.message, type = _entry$event.type, _entry$originatorMeta = entry.originatorMetadata, id = _entry$originatorMeta.id, role = _entry$originatorMeta.role, sequence = entry.sequence;

                        if (!(sequence && sequence > 0)) {
                          _context27.next = 6;
                          break;
                        }

                        _this10.conversationSequenceNumber = sequence;
                        _context27.next = 6;
                        return regeneratorRuntime.awrap((0, _helpStorage.setItem)(_LiveEngageConfig.LE_CONVERSATION_SEQUENCE_NUMBER_KEY, sequence));

                      case 6:
                        if (!((role === LEMessage.ROLE_ASSIGNED_AGENT || role === LEMessage.ROLE_MANAGER || role === LEMessage.ROLE_CONTROLLER) && type === LEMessage.MESSAGE_TYPE_CONTENT_EVENT)) {
                          _context27.next = 10;
                          break;
                        }

                        _context27.next = 9;
                        return regeneratorRuntime.awrap(_this10.handleMessageReceived(id, message));

                      case 9:
                        return _context27.abrupt("return", _context27.sent);

                      case 10:
                        if (!((role === LEMessage.ROLE_ASSIGNED_AGENT || role === LEMessage.ROLE_MANAGER) && chatState === LEMessage.CHAT_STATE_COMPOSING && _this10.agentData && _this10.managerData.concat([_this10.agentData]).findIndex(function (guide) {
                          return guide.id === id;
                        }) > -1)) {
                          _context27.next = 15;
                          break;
                        }

                        _this10.store.dispatch((0, _app.appTypingSet)(true));

                        clearTimeout(_this10.typingAgentTimeout);
                        _this10.typingAgentTimeout = setTimeout(function () {
                          _this10.store.dispatch((0, _app.appTypingSet)(false));
                        }, 8000);
                        return _context27.abrupt("return");

                      case 15:
                      case "end":
                        return _context27.stop();
                    }
                  }
                });
              }));

            case 3:
            case "end":
              return _context28.stop();
          }
        }
      });
    }
  }, {
    key: "handleConvChangedNotify",
    value: function handleConvChangedNotify(data) {
      var _this11 = this;

      var messageEventData;
      return regeneratorRuntime.async(function handleConvChangedNotify$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              messageEventData = data && data.body && data.body.changes && data.body.changes;
              _context30.next = 3;
              return regeneratorRuntime.awrap(messageEventData.forEach(function _callee4(entry) {
                var result, type, newConvId;
                return regeneratorRuntime.async(function _callee4$(_context29) {
                  while (1) {
                    switch (_context29.prev = _context29.next) {
                      case 0:
                        result = entry.result, type = entry.type;
                        _context29.t0 = type;
                        _context29.next = _context29.t0 === LEMessage.MESSAGE_TYPE_DELETE ? 4 : _context29.t0 === LEMessage.MESSAGE_TYPE_UPSERT ? 11 : 26;
                        break;

                      case 4:
                        if (!_this11.userLeavingChatQueue) {
                          _context29.next = 8;
                          break;
                        }

                        _context29.next = 7;
                        return regeneratorRuntime.awrap(_this11.handleUserLeftChatQueue());

                      case 7:
                        return _context29.abrupt("return", _context29.sent);

                      case 8:
                        _context29.next = 10;
                        return regeneratorRuntime.awrap(_this11.handleConversationEnded());

                      case 10:
                        return _context29.abrupt("return", _context29.sent);

                      case 11:
                        if (!(result && result.convId)) {
                          _context29.next = 25;
                          break;
                        }

                        newConvId = result.convId;

                        if (!(newConvId !== _this11.conversationId)) {
                          _context29.next = 23;
                          break;
                        }

                        _this11.conversationId = result.convId;
                        _context29.next = 17;
                        return regeneratorRuntime.awrap((0, _helpStorage.setItem)(_LiveEngageConfig.LE_CONVERSATION_ID_KEY, data.body.conversationId));

                      case 17:
                        _this11.conversationSequenceNumber = 0;
                        _context29.next = 20;
                        return regeneratorRuntime.awrap((0, _helpStorage.setItem)(_LiveEngageConfig.LE_CONVERSATION_SEQUENCE_NUMBER_KEY, 0));

                      case 20:
                        _context29.next = 22;
                        return regeneratorRuntime.awrap(_this11.sendSocketMessage(LEMessage.subscribeMessagingEvents({
                          conversationId: _this11.conversationId,
                          sequenceNumber: _this11.conversationSequenceNumber
                        })));

                      case 22:
                        return _context29.abrupt("return", _context29.sent);

                      case 23:
                        _context29.next = 25;
                        return regeneratorRuntime.awrap(_this11.updateParticipants(result.conversationDetails.participants));

                      case 25:
                        return _context29.abrupt("break", 27);

                      case 26:
                        return _context29.abrupt("break", 27);

                      case 27:
                      case "end":
                        return _context29.stop();
                    }
                  }
                });
              }));

            case 3:
            case "end":
              return _context30.stop();
          }
        }
      });
    }
  }, {
    key: "updateParticipants",
    value: function updateParticipants(participants) {
      var _this12 = this;

      var assignedAgent, assignedAgentId, updatedAgentData, assignedManagers;
      return regeneratorRuntime.async(function updateParticipants$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              assignedAgent = participants.find(function (p) {
                return p.role === LEMessage.ROLE_ASSIGNED_AGENT;
              });

              if (!assignedAgent) {
                _context31.next = 24;
                break;
              }

              assignedAgentId = assignedAgent.id;

              if (!this.agentConnected) {
                _context31.next = 21;
                break;
              }

              if (!(this.agentData.id !== assignedAgentId)) {
                _context31.next = 19;
                break;
              }

              if (!this.managerData.find(function (mananger) {
                return mananger.id === assignedAgentId;
              })) {
                _context31.next = 13;
                break;
              }

              _context31.next = 8;
              return regeneratorRuntime.awrap(this.handleAgentDisconnected());

            case 8:
              updatedAgentData = this.participantProfileData[assignedAgentId];
              this.agentData = _objectSpread({
                id: assignedAgentId
              }, updatedAgentData);
              this.managerData = this.managerData.filter(function (mananger) {
                return mananger.id !== assignedAgentId;
              });
              _context31.next = 19;
              break;

            case 13:
              _context31.next = 15;
              return regeneratorRuntime.awrap(this.handleAgentDisconnected(this.agentData.id));

            case 15:
              this.agentData = {
                id: assignedAgentId
              };
              this.agentConnected = false;
              _context31.next = 19;
              return regeneratorRuntime.awrap(this.handleAgentConnected());

            case 19:
              _context31.next = 24;
              break;

            case 21:
              this.agentData = {
                id: assignedAgentId
              };
              _context31.next = 24;
              return regeneratorRuntime.awrap(this.handleAgentConnected());

            case 24:
              assignedManagers = participants.filter(function (p) {
                return p.role === LEMessage.ROLE_MANAGER;
              }) // The first two managers are always bots
              .slice(2); // Check for manangers that have connected

              assignedManagers.forEach(function (mananger) {
                if (!_this12.managerData.find(function (existingManager) {
                  return existingManager.id === mananger.id;
                })) {
                  _this12.managerData.push({
                    id: mananger.id
                  });

                  _this12.handleManagerConnected(mananger.id);
                }
              }); // Check for manangers that have disconnected

              this.managerData.forEach(function (mananger) {
                if (!assignedManagers.find(function (assignedManager) {
                  return assignedManager.id === mananger.id;
                })) {
                  _this12.handleManagerDisonnected(mananger.id);
                }
              });

            case 27:
            case "end":
              return _context31.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "setSocketOnMessage",
    value: function setSocketOnMessage() {
      var _this13 = this;

      return regeneratorRuntime.async(function setSocketOnMessage$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              this.ws.onmessage = function _callee5(socketMessage) {
                var data;
                return regeneratorRuntime.async(function _callee5$(_context32) {
                  while (1) {
                    switch (_context32.prev = _context32.next) {
                      case 0:
                        _this13.store.dispatch((0, _traffic.trafficLESocketOnMessage)(JSON.stringify(socketMessage) || ''));

                        data = socketMessage.data && JSON.parse(socketMessage.data);

                        _this13.log('LE-EVENT:', data.type, data);

                        if (!(data && data.type)) {
                          _context32.next = 22;
                          break;
                        }

                        _context32.t0 = data.type;
                        _context32.next = _context32.t0 === LEMessage.REQUEST_CONVERSATIONAL_RESPONSE ? 7 : _context32.t0 === LEMessage.STRING_RESPONSE ? 11 : _context32.t0 === LEMessage.EX_CONVERSATION_CHANGE_NOTIFICATION ? 15 : _context32.t0 === LEMessage.MESSAGING_EVENT_NOTIFICATION ? 18 : 21;
                        break;

                      case 7:
                        _this13.conversationId = data.body && data.body.conversationId && data.body.conversationId;
                        _context32.next = 10;
                        return regeneratorRuntime.awrap((0, _helpStorage.setItem)(_LiveEngageConfig.LE_CONVERSATION_ID_KEY, data.body.conversationId));

                      case 10:
                        return _context32.abrupt("return");

                      case 11:
                        if (!(data.body === LEMessage.STRING_RESPONSE_CONNECTED)) {
                          _context32.next = 14;
                          break;
                        }

                        _context32.next = 14;
                        return regeneratorRuntime.awrap(_this13.handleConversationStarted());

                      case 14:
                        return _context32.abrupt("return");

                      case 15:
                        _context32.next = 17;
                        return regeneratorRuntime.awrap(_this13.handleConvChangedNotify(data));

                      case 17:
                        return _context32.abrupt("return", _context32.sent);

                      case 18:
                        _context32.next = 20;
                        return regeneratorRuntime.awrap(_this13.handleMessagingEventNotify(data));

                      case 20:
                        return _context32.abrupt("return", _context32.sent);

                      case 21:
                        return _context32.abrupt("break", 22);

                      case 22:
                      case "end":
                        return _context32.stop();
                    }
                  }
                });
              };

            case 1:
            case "end":
              return _context33.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "setSocketOnClose",
    value: function setSocketOnClose() {
      var _this14 = this;

      return regeneratorRuntime.async(function setSocketOnClose$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              this.log('SOCKET: setting socket on close.');

              this.ws.onclose = function _callee6(event) {
                return regeneratorRuntime.async(function _callee6$(_context34) {
                  while (1) {
                    switch (_context34.prev = _context34.next) {
                      case 0:
                        _this14.ws = null;

                        _this14.log('SOCKET: socket on close.', event);

                        _this14.store.dispatch((0, _traffic.trafficLESocketOnClose)());

                        _this14.runKeepAlive = false;

                        if (!(event && event.code === 4407)) {
                          _context34.next = 9;
                          break;
                        }

                        _this14.log('SOCKET: socket on close - Refreshing token');

                        _this14.shouldRefreshToken = true;
                        _context34.next = 9;
                        return regeneratorRuntime.awrap(_this14.init());

                      case 9:
                      case "end":
                        return _context34.stop();
                    }
                  }
                });
              };

            case 2:
            case "end":
              return _context35.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "sendSocketMessage",
    value: function sendSocketMessage(_ref3) {
      var type, body, headers;
      return regeneratorRuntime.async(function sendSocketMessage$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              type = _ref3.type, body = _ref3.body, headers = _ref3.headers;

              if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.log('LE-SEND:', LEMessage.messageObject({
                  type: type,
                  body: body,
                  headers: headers
                }));
                this.ws.send(JSON.stringify(LEMessage.messageObject({
                  type: type,
                  body: body,
                  headers: headers
                })));
              }

            case 2:
            case "end":
              return _context36.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "send",
    value: function send(message) {
      return regeneratorRuntime.async(function send$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              this.log("%cMessage: ".concat(message), (0, _util.consoleCss)('#E3DFFF', '#94524A'));
              _context37.next = 3;
              return regeneratorRuntime.awrap(this.sendSocketMessage(LEMessage.publishEvent(this.conversationId, message)));

            case 3:
            case "end":
              return _context37.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleMessageReceived",
    value: function handleMessageReceived(participantId, message) {
      var response, participantData;
      return regeneratorRuntime.async(function handleMessageReceived$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              this.log("%cLE Message: ".concat(JSON.stringify(message)), (0, _util.consoleCss)('#BBB', '#3A506B')); // Todo Support Secure Message and image attachments

              if (!(typeof message !== 'string')) {
                _context38.next = 3;
                break;
              }

              return _context38.abrupt("return");

            case 3:
              response = {
                error: null,
                responses: []
              };
              participantData = this.participantProfileData[participantId];
              response.responses.push({
                type: _constants.CONVERSATION_TYPE_TEXT_HUMAN,
                items: [message, participantData ? participantData.pictureUrl : ''],
                participantId: participantId
              }); // todo mask traffic message

              this.store.dispatch((0, _traffic.trafficAgentActionMessageSent)({
                message: message
              }));
              _context38.next = 9;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.conversationQueueAppend)(response.responses)));

            case 9:
              _context38.next = 11;
              return regeneratorRuntime.awrap(this.store.dispatch((0, _conversation.processQueue)()));

            case 11:
            case "end":
              return _context38.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "handleTypingUserPing",
    value: function handleTypingUserPing() {
      var _this15 = this;

      return regeneratorRuntime.async(function handleTypingUserPing$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              // set user typing to "on"
              this.sendChatState(LEMessage.CHAT_STATE_COMPOSING);
              clearTimeout(this.typingUserTimeout);
              this.typingUserTimeout = setTimeout(function () {
                // set user typing to "off"
                _this15.sendChatState(LEMessage.CHAT_STATE_ACTIVE);
              }, 3000);

            case 3:
            case "end":
              return _context39.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getSDEs",
    value: function getSDEs() {
      var sdes, userInfo, product;
      return regeneratorRuntime.async(function getSDEs$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              sdes = [];
              userInfo = (0, _util.getUserInfo)();
              product = (0, _app2.getAppProduct)(this.store.getState());

              if (userInfo) {
                sdes.push({
                  type: 'personal',
                  personal: {
                    firstname: userInfo.firstName,
                    lastname: userInfo.lastName
                  }
                });
                sdes.push({
                  type: 'ctmrinfo',
                  info: {
                    userInfo: userInfo.visitorId || null,
                    accountName: userInfo.pathway || null,
                    ctype: product || null,
                    customerId: userInfo.shopperId || null,
                    socialId: userInfo.socialId || null
                  }
                });
              }

              return _context40.abrupt("return", sdes);

            case 5:
            case "end":
              return _context40.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "log",
    value: function log() {
      // eslint-disable-next-line no-console
      this.debug() && console.info.apply(console, arguments);
    }
  }]);

  return LiveEngage;
}();

exports.LiveEngage = LiveEngage;

var _default = new LiveEngage();

exports["default"] = _default;